import path from 'path'
import fs from 'fs'
import colors from 'chalk'
import { execSync, spawn } from 'child_process'
import { logMessage, infoMessage, errorMessage } from './terminal-utils'
import { killProcessTree } from './utils'
import net from 'net'
// import helmet from 'helmet'
// const RateLimit = require('express-rate-limit');

import { DEFAULT_DEV_SERVER_PORT } from './utils'

const ENFORCE_PORT_LIMIT = 30

function getAvailablePort (startingAt) {

    function getNextAvailablePort (currentPort, cb) {
        const server = net.createServer()
        server.listen(currentPort, _ => {
            server.once('close', _ => {
                cb(currentPort)
            })
            server.close()
        })
        server.on('error', _ => {
            getNextAvailablePort(currentPort + 1, cb)
        })
    }

    return new Promise(resolve => {
        getNextAvailablePort(startingAt, resolve)
    })
}
  
const HTTP_SERVER = {
    // status: false,
    src: '',
    service: false,
    enforcePortCounter: 0,
    async isPortInUse (nodeServicePath, opts) { //port, autoKill = false) {
        return new Promise(async (resolve, reject) => {
            let port = await getAvailablePort(opts.server.port)

            // original port was in use
            if (port !== opts.server.port) {
                // if enforcePort is on, we must try and kill the process that
                // is currently using that port
                if (opts.server.enforcePort) {
                    // we will find its service
                    let extraInfo = execSync(
                        `lsof -i:${opts.server.port} -Fp`
                        // `ps -ax | grep "${nodeServicePath} spawned ${opts.server.port}"`
                    ).toString()

                    if (extraInfo) {
                        let pid = extraInfo.split('\n')[0].replace(/\D/g, '')

                        // if we tried it many times and still couldn't get the door
                        // we give up
                        if (this.enforcePortCounter > ENFORCE_PORT_LIMIT) {
                            resolve(pid)
                            return
                        }

                        // now...it's time for violence!
                        try{
                            await killProcessTree(pid)
                            this.enforcePortCounter++
                            
                            // execSync(`kill -9 ${pid}`)
                            return this.isPortInUse(nodeServicePath, opts)
                                .then(resolve)
                            // resolve(false)
                        } catch (e) {
                            resolve(pid)
                        }
                    }
                    resolve()
                    return
                }
                // if port lookup is enabled, we look for the next available port
                if (opts.server.portLookup) {
                    opts.server.port = port
                    resolve()
                    return
                }
            }
            resolve()
        })
    },

    async start (data) {
        let { compiler, opts, config, paths, stats } = data
        opts.server = opts.server || {}
        opts.server.port = opts.server.port || DEFAULT_DEV_SERVER_PORT

        // if the server has already started, we stop it
        if (HTTP_SERVER.service) {
            try {
                HTTP_SERVER.service.kill()
            } catch (e) {}
        }

        let spawnOpts = {
            env: process.env
        }
        if (opts.server.verbose) {
            spawnOpts.stdio = [
                0, // Use parent's stdin for child
                'pipe', // Pipe child's stdout to parent
                // fs.openSync('err.out', 'w') // Direct child's stderr to a file
            ]
        }

        const nodeServicePath = path.resolve(paths.dist, 'server')
        
        let portInUse = await this.isPortInUse(nodeServicePath, opts)

        HTTP_SERVER.service = spawn(
            'node',
            [
                nodeServicePath,
                'spawned',
                opts.server.port
            ],
            spawnOpts
        )

        global.httpServerProcess = HTTP_SERVER.service

        stats.httpServerService = HTTP_SERVER.service

        HTTP_SERVER.service.stdout.on('data', (data) => {
            if (opts.server.verbose) {
                console.log(logMessage(data))
            }
        });

        HTTP_SERVER.service.stderr.on('data', (data) => {
            // in case of any error, we deal with it
            data = data.message || data
            data = data.toString()

            // console.warn is treated as error in node
            // let's show it differently
            let isWarning = false
            if (data.startsWith('__FURTHER__WARNING__MESSAGE__')) {
                data = data.replace('__FURTHER__WARNING__MESSAGE__', '')
                isWarning = true
            }

            let extraInfo = ''
            // if the problem is that the port is in use
            if (data.indexOf && data.indexOf('EADDRINUSE') >= 0) {
                // we will look for the current PID using it
                if (portInUse) {
                    extraInfo = `The most likely PID using that port is ${colors.bold.red(portInUse)}\n`+
                        `Try killing it with: ${colors.bold.white.bgBlueBright(`kill -9 ${portInUse}`)}`
                }
            }

            stats.compilation[
                isWarning
                    ? 'warnings'
                    : 'errors'
            ].push({
                name: 'HTTP Server Startup',
                message: `${data.message || data}\n${extraInfo}`
            })
        })
          
        HTTP_SERVER.service.on('close', (code) => {
            if (opts.server.verbose) {
                console.log(infoMessage('HTTP Server stoped. Code: ' + code))
            }
        })
        return HTTP_SERVER.service
    }
}

export default HTTP_SERVER



// WEBPACK FOOTER //
// ./src/http-server.js